import type { QueryClient } from '@tanstack/react-query';

import { conversationQueryOptions } from './use-conversation';
import { conversationMessagesQueryOptions } from './use-conversation-messages';

/**
 * Route loader: the detail is awaited (its number is the crumb), the thread starts loading in
 * parallel and the page shows its own skeleton if it is still on the way.
 */
export async function prefetchConversation(
  queryClient: QueryClient,
  storeId: string,
  id: string,
): Promise<string> {
  void queryClient
    .infiniteQuery(conversationMessagesQueryOptions(storeId, id))
    .catch(() => undefined);
  const conversation = await queryClient.query({
    ...conversationQueryOptions(storeId, id),
    staleTime: 'static',
  });
  return `#${conversation.number}`;
}
